import * as THREE from "three";
import {
  acceleratedRaycast,
  computeBoundsTree,
  disposeBoundsTree,
} from "three-mesh-bvh";

(THREE.Mesh as any).prototype.raycast = acceleratedRaycast as any;
(THREE.BufferGeometry as any).prototype.computeBoundsTree =
  computeBoundsTree as any;
(THREE.BufferGeometry as any).prototype.disposeBoundsTree =
  disposeBoundsTree as any;
